import { toast } from "react-toastify";
import { AutherizeSSOUser } from "../api/apiConfig";
import { NavigateFunction } from "react-router-dom";

export const performSSOLogin = async(JWTToken: string, navigate:NavigateFunction)=>{
  try{
    return await AutherizeSSOUser(JWTToken , navigate);
  }catch (err: unknown) {
    throw err;
  }
}

export const logout = (navigate: (path: string) => void) => {
  localStorage.clear();
  sessionStorage.clear();
  if (caches) {
      caches.keys().then(keys => {
          keys.forEach(key => caches.delete(key));
      });
  }
  toast.info("Logged out successfully!");
  navigate("/auth");
};